// TODO: i18n — see Auth.js for pattern, replace hardcoded strings with t('namespace.key')
import { useState, useEffect } from 'react'
import { supabase } from '../supabase'
import ContractorDetail from './ContractorDetail'
import { formatPhone } from '../utils/formatPhone'

const C = {
  bg: '#F2EDE4', card: '#FDFAF6', border: '#DDD4C6',
  amber: '#B8721F', amberLight: '#D4902A', brown: '#2C1D14',
  muted: '#9A7B68', success: '#2E6B4A', danger: '#B03020',
}
const f = 'Georgia, serif'

export const CONTRACTOR_CATEGORIES = ['HVAC', 'Plumbing', 'Roofing', 'Appliance Repair', 'Electrical', 'Landscaping', 'Handyman', 'General Contractor', 'General']

export const CAT_ICONS = {
  'HVAC': '🌬️', 'Plumbing': '🚰', 'Roofing': '🏠',
  'Appliance Repair': '🔧', 'Electrical': '⚡',
  'Landscaping': '🌿', 'General': '🔨',
  'Handyman': '🔧', 'General Contractor': '🏗️',
}

export const HOME_SERVICE_CATEGORIES = ['Housekeeping', 'Landscaping', 'Pest Control', 'Pool Service', 'Smoke/Fire Recovery', 'Window Cleaning', 'Gutter Cleaning']

export const HOME_SERVICE_ICONS = {
  'Housekeeping': '🧹', 'Landscaping': '🌿', 'Pest Control': '🪲',
  'Pool Service': '🏊', 'Smoke/Fire Recovery': '🚒',
  'Window Cleaning': '🪟', 'Gutter Cleaning': '🍂',
}

export const ITEM_TO_CONTRACTOR_CAT = {
  hvac: 'HVAC', water_heater: 'Plumbing', dryer: 'Appliance Repair',
  refrigerator: 'Appliance Repair', washer: 'Appliance Repair',
  dishwasher: 'Appliance Repair', oven: 'Appliance Repair',
  microwave: 'Appliance Repair', garbage_disposal: 'Plumbing',
  smoke_detector: 'Electrical', garage_door: 'General',
  septic: 'Plumbing', solar: 'Electrical', pool: 'General',
  well: 'Plumbing', propane: 'General', generator: 'Electrical',
  battery: 'Electrical', sump_pump: 'Plumbing', whole_house_fan: 'HVAC',
  water_softener: 'Plumbing', radiant_heat: 'HVAC',
  electrical_panel: 'Electrical', adu: 'General Contractor', other: 'General',
  fireplace: 'General', fire_sprinkler: 'General Contractor', air_filtration: 'HVAC',
}

export function Stars({ rating, size = 14, interactive = false, hovered = 0, onHover, onClick }) {
  return (
    <span style={{ display: 'inline-flex', gap: '1px' }}>
      {[1, 2, 3, 4, 5].map(i => (
        <span
          key={i}
          style={{
            fontSize: `${size}px`, color: i <= (hovered || Math.round(rating)) ? C.amber : C.border,
            cursor: interactive ? 'pointer' : 'default',
            transition: 'color 0.1s',
          }}
          onMouseEnter={() => interactive && onHover?.(i)}
          onMouseLeave={() => interactive && onHover?.(0)}
          onClick={() => interactive && onClick?.(i)}
        >★</span>
      ))}
    </span>
  )
}

const S = {
  overlay: {
    position: 'fixed', inset: 0, background: 'rgba(44,29,20,0.4)',
    zIndex: 1000, fontFamily: f,
  },
  panel: {
    position: 'fixed', top: 0, right: 0, bottom: 0,
    width: '100%', maxWidth: '600px',
    background: C.card, boxShadow: '-8px 0 40px rgba(44,29,20,0.15)',
    borderLeft: `1px solid ${C.border}`, overflowY: 'auto', zIndex: 1001,
  },
  header: {
    padding: '20px 24px', display: 'flex', justifyContent: 'space-between',
    alignItems: 'center', borderBottom: `1px solid ${C.border}`,
    position: 'sticky', top: 0, background: C.card, zIndex: 10, gap: '12px',
  },
  closeBtn: { background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer', color: C.muted, padding: 0, lineHeight: 1 },
  filterBar: {
    padding: '12px 24px', borderBottom: `1px solid ${C.border}`,
    position: 'sticky', top: '65px', background: C.card, zIndex: 9,
  },
  typeToggle: {
    display: 'flex', gap: '8px', marginBottom: '10px',
  },
  typeBtn: (active) => ({
    flex: 1, padding: '8px 12px', borderRadius: '8px', cursor: 'pointer',
    fontSize: '12px', fontFamily: 'Calibri, sans-serif', fontWeight: active ? '700' : '400',
    border: `1px solid ${active ? C.amber : C.border}`,
    background: active ? '#FBF3E8' : 'transparent',
    color: active ? C.amber : C.muted,
    transition: 'all 0.15s', textAlign: 'center',
  }),
  searchInput: {
    width: '100%', background: C.bg, border: `1px solid ${C.border}`,
    borderRadius: '8px', padding: '9px 14px', fontSize: '14px',
    fontFamily: f, color: C.brown, boxSizing: 'border-box',
    outline: 'none', marginBottom: '10px',
  },
  catRow: { display: 'flex', gap: '8px', overflowX: 'auto', scrollbarWidth: 'none' },
  catPill: (active) => ({
    padding: '5px 12px', borderRadius: '20px', whiteSpace: 'nowrap',
    fontSize: '12px', fontFamily: 'Calibri, sans-serif', cursor: 'pointer',
    border: `1px solid ${active ? C.amber : C.border}`,
    background: active ? '#FBF3E8' : 'transparent',
    color: active ? C.amber : C.muted,
    fontWeight: active ? '700' : '400',
    transition: 'all 0.15s', flexShrink: 0,
  }),
  body: { padding: '20px 24px' },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
    gap: '14px',
  },
  card: {
    background: C.bg, borderRadius: '14px', border: `1px solid ${C.border}`,
    padding: '16px', display: 'flex', flexDirection: 'column', gap: '6px',
    boxShadow: '0 2px 8px rgba(44,29,20,0.04)',
  },
  cardTop: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2px' },
  catBadge: {
    fontSize: '11px', padding: '3px 10px', borderRadius: '20px',
    background: '#FBF3E8', color: C.amber, border: `1px solid ${C.amber}33`,
    fontFamily: 'Calibri, sans-serif', whiteSpace: 'nowrap',
  },
  verifiedBadge: {
    fontSize: '10px', padding: '2px 8px', borderRadius: '20px',
    background: '#EBF5EF', color: C.success, border: `1px solid ${C.success}33`,
    fontFamily: 'Calibri, sans-serif',
  },
  cardName: { fontSize: '15px', fontWeight: '700', color: C.brown, lineHeight: 1.2 },
  ratingRow: { display: 'flex', alignItems: 'center', gap: '6px' },
  ratingText: { fontSize: '12px', color: C.muted, fontFamily: 'Calibri, sans-serif' },
  detailLine: { fontSize: '12px', color: C.muted, fontFamily: 'Calibri, sans-serif' },
  phoneLink: {
    fontSize: '13px', color: C.amber, fontFamily: 'Calibri, sans-serif',
    textDecoration: 'none', fontWeight: '600', display: 'block',
  },
  viewBtn: {
    marginTop: '6px', background: `linear-gradient(135deg, ${C.amber}, ${C.amberLight})`,
    border: 'none', borderRadius: '8px', padding: '9px 14px',
    fontSize: '12px', color: C.card, fontWeight: '700',
    cursor: 'pointer', fontFamily: f, letterSpacing: '1px',
    textTransform: 'uppercase', width: '100%',
  },
  emptyState: {
    textAlign: 'center', padding: '60px 24px',
  },
  recommendBtn: {
    background: 'transparent', border: `1px solid ${C.amber}44`,
    borderRadius: '8px', padding: '8px 14px', fontSize: '12px',
    color: C.amber, cursor: 'pointer', fontFamily: 'Calibri, sans-serif',
    marginTop: '12px', width: '100%',
  },
  modalOverlay: {
    position: 'fixed', inset: 0, background: 'rgba(44,29,20,0.6)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 1200, padding: '20px', fontFamily: f,
  },
  modal: {
    background: C.card, borderRadius: '16px', width: '100%',
    maxWidth: '480px', maxHeight: '90vh', overflowY: 'auto',
    boxShadow: '0 8px 40px rgba(44,29,20,0.25)', border: `1px solid ${C.border}`,
    padding: '28px',
  },
  label: { fontSize: '10px', color: C.muted, letterSpacing: '1.5px', textTransform: 'uppercase', marginBottom: '5px', display: 'block', fontFamily: 'Calibri, sans-serif' },
  input: { width: '100%', background: C.bg, border: `1px solid ${C.border}`, borderRadius: '8px', padding: '10px 14px', fontSize: '14px', fontFamily: f, color: C.brown, boxSizing: 'border-box', outline: 'none', marginBottom: '14px' },
  select: { width: '100%', background: C.bg, border: `1px solid ${C.border}`, borderRadius: '8px', padding: '10px 14px', fontSize: '14px', fontFamily: f, color: C.brown, boxSizing: 'border-box', outline: 'none', marginBottom: '14px', appearance: 'none' },
  textarea: { width: '100%', background: C.bg, border: `1px solid ${C.border}`, borderRadius: '8px', padding: '10px 14px', fontSize: '14px', fontFamily: f, color: C.brown, boxSizing: 'border-box', outline: 'none', marginBottom: '14px', resize: 'vertical', minHeight: '80px' },
  submitBtn: (disabled) => ({
    width: '100%', background: disabled ? C.bg : `linear-gradient(135deg, ${C.amber}, ${C.amberLight})`,
    border: `1px solid ${disabled ? C.border : 'transparent'}`, borderRadius: '10px', padding: '13px',
    color: disabled ? C.muted : C.card, fontSize: '13px', fontWeight: '700',
    cursor: disabled ? 'not-allowed' : 'pointer', fontFamily: f, letterSpacing: '1.5px', textTransform: 'uppercase',
  }),
  cancelBtn: { width: '100%', background: 'transparent', border: `1px solid ${C.border}`, borderRadius: '10px', padding: '11px', color: C.muted, fontSize: '13px', cursor: 'pointer', fontFamily: f, marginTop: '10px' },
  alert: (type) => ({
    borderRadius: '8px', padding: '10px 14px', marginBottom: '14px', fontSize: '13px', fontFamily: 'Calibri, sans-serif',
    background: type === 'error' ? '#FDECEA' : '#EBF5EF',
    border: `1px solid ${type === 'error' ? C.danger : C.success}44`,
    color: type === 'error' ? C.danger : C.success,
  }),
}

export default function ContractorDirectory({ session, onClose, initialCategory = '', initialListingType = 'contractor' }) {
  const [contractors, setContractors] = useState([])
  const [loading, setLoading] = useState(true)
  const [search, setSearch] = useState('')
  const [listingType, setListingType] = useState(initialListingType)
  const [activeCategory, setActiveCategory] = useState(initialCategory)
  const [selectedContractor, setSelectedContractor] = useState(null)
  const [showRecommend, setShowRecommend] = useState(false)
  const [recommendForm, setRecommendForm] = useState({ business_name: '', category: '', phone: '', listing_type: 'contractor', reviewer_note: '' })
  const [recommendSubmitting, setRecommendSubmitting] = useState(false)
  const [recommendAlert, setRecommendAlert] = useState(null)

  useEffect(() => { fetchContractors() }, [])

  const fetchContractors = async () => {
    const { data } = await supabase.from('contractors').select('*')
      .eq('active', true).order('rating', { ascending: false })
    setContractors(data || [])
    setLoading(false)
  }

  const categories = listingType === 'contractor' ? CONTRACTOR_CATEGORIES : HOME_SERVICE_CATEGORIES
  const catIcons = listingType === 'contractor' ? CAT_ICONS : HOME_SERVICE_ICONS

  const filtered = contractors.filter(c => {
    const matchType = (c.listing_type || 'contractor') === listingType
    const matchCat = !activeCategory || (c.category || []).some(cat => cat.toLowerCase() === activeCategory.toLowerCase())
    const matchSearch = !search.trim() ||
      c.name.toLowerCase().includes(search.toLowerCase()) ||
      c.description?.toLowerCase().includes(search.toLowerCase()) ||
      c.service_area?.toLowerCase().includes(search.toLowerCase())
    return matchType && matchCat && matchSearch
  })

  const handleSwitchType = (type) => {
    setListingType(type)
    setActiveCategory('')
    setSearch('')
  }

  const setRecommend = (field) => (e) => {
    setRecommendForm(f => ({ ...f, [field]: e.target.value }))
    setRecommendAlert(null)
  }

  const handleRecommendSubmit = async () => {
    if (!recommendForm.business_name.trim()) {
      setRecommendAlert({ type: 'error', msg: 'Please enter a business name.' })
      return
    }
    setRecommendSubmitting(true)
    setRecommendAlert(null)
    const { error } = await supabase.from('pending_vendors').insert({
      user_id: session.user.id,
      business_name: recommendForm.business_name.trim(),
      category: recommendForm.category || null,
      phone: recommendForm.phone.trim() || null,
      listing_type: recommendForm.listing_type,
      reviewer_note: recommendForm.reviewer_note.trim() || null,
      approved: false,
    })
    setRecommendSubmitting(false)
    if (error) {
      setRecommendAlert({ type: 'error', msg: 'Error submitting. Please try again.' })
    } else {
      setRecommendAlert({ type: 'success', msg: "Thanks! We'll review your recommendation soon." })
      setTimeout(() => {
        setShowRecommend(false)
        setRecommendAlert(null)
        setRecommendForm({ business_name: '', category: '', phone: '', listing_type: 'contractor', reviewer_note: '' })
      }, 2500)
    }
  }

  const recommendCategories = recommendForm.listing_type === 'contractor' ? CONTRACTOR_CATEGORIES : HOME_SERVICE_CATEGORIES

  return (
    <>
      <div style={S.overlay} onClick={(e) => e.target === e.currentTarget && onClose()} />
      <div style={S.panel}>

        {/* Header */}
        <div style={S.header} className="casavio-header">
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: '20px', fontWeight: '700', color: C.brown }}>
              {listingType === 'contractor' ? '🔨 Find a Contractor' : '🏠 Find a Home Service'}
            </div>
            <div style={{ fontSize: '12px', color: C.muted, fontFamily: 'Calibri, sans-serif', marginTop: '2px' }}>
              {filtered.length} listing{filtered.length !== 1 ? 's' : ''} found
            </div>
          </div>
          <button style={S.closeBtn} onClick={onClose}>×</button>
        </div>

        {/* Filters */}
        <div style={S.filterBar}>
          {/* Type toggle */}
          <div style={S.typeToggle}>
            <div style={S.typeBtn(listingType === 'contractor')} onClick={() => handleSwitchType('contractor')}>
              🔨 Contractors
            </div>
            <div style={S.typeBtn(listingType === 'service')} onClick={() => handleSwitchType('service')}>
              🏠 Home Services
            </div>
          </div>

          <input
            style={S.searchInput}
            placeholder={listingType === 'contractor' ? 'Search by name or specialty...' : 'Search by name or service...'}
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
          <div style={S.catRow}>
            <div style={S.catPill(!activeCategory)} onClick={() => setActiveCategory('')}>All</div>
            {categories.map(cat => (
              <div key={cat} style={S.catPill(activeCategory === cat)} onClick={() => setActiveCategory(cat)}>
                {catIcons[cat]} {cat}
              </div>
            ))}
          </div>
        </div>

        {/* Body */}
        <div style={S.body} className="casavio-content">
          {loading ? (
            <div style={{ color: C.muted, fontStyle: 'italic', fontFamily: 'Calibri, sans-serif' }}>Loading...</div>
          ) : filtered.length === 0 ? (
            <div style={S.emptyState}>
              <div style={{ fontSize: '40px', marginBottom: '12px' }}>🔍</div>
              <div style={{ fontSize: '16px', fontWeight: '700', color: C.brown, marginBottom: '6px' }}>No listings found</div>
              <div style={{ fontSize: '13px', color: C.muted, fontFamily: 'Calibri, sans-serif' }}>
                {search ? 'Try a different search term.' : `No ${listingType === 'contractor' ? 'contractors' : 'services'} in this category yet.`}
              </div>
            </div>
          ) : (
            <div style={S.grid}>
              {filtered.map(c => (
                <ContractorCard key={c.id} contractor={c} catIcon={catIcons[c.category] || (listingType === 'contractor' ? CAT_ICONS[c.category] : HOME_SERVICE_ICONS[c.category]) || '🔧'} onSelect={setSelectedContractor} />
              ))}
            </div>
          )}

          <button style={S.recommendBtn} onClick={() => setShowRecommend(true)}>
            ✉️ Recommend a Vendor — know a great business? Let us know
          </button>
        </div>
      </div>

      {selectedContractor && (
        <ContractorDetail
          contractor={selectedContractor}
          session={session}
          onClose={() => setSelectedContractor(null)}
          onReviewSubmitted={() => { fetchContractors(); setSelectedContractor(null) }}
        />
      )}

      {/* Recommend a Vendor Modal */}
      {showRecommend && (
        <div style={S.modalOverlay} onClick={(e) => e.target === e.currentTarget && setShowRecommend(false)}>
          <div style={S.modal}>
            <div style={{ fontSize: '20px', fontWeight: '700', color: C.brown, marginBottom: '4px' }}>Recommend a Vendor</div>
            <div style={{ fontSize: '13px', color: C.muted, fontFamily: 'Calibri, sans-serif', marginBottom: '20px' }}>
              Know a great contractor or service? We'll review your submission and add them to the directory.
            </div>

            {recommendAlert && <div style={S.alert(recommendAlert.type)}>{recommendAlert.msg}</div>}

            <label style={S.label}>Business Name *</label>
            <input style={S.input} placeholder="e.g. Summit HVAC Services" value={recommendForm.business_name} onChange={setRecommend('business_name')} />

            <label style={S.label}>Listing Type</label>
            <select style={S.select} value={recommendForm.listing_type} onChange={setRecommend('listing_type')}>
              <option value="contractor">Contractor</option>
              <option value="service">Home Service</option>
            </select>

            <label style={S.label}>Category</label>
            <select style={S.select} value={recommendForm.category} onChange={setRecommend('category')}>
              <option value="">Select category...</option>
              {recommendCategories.map(c => <option key={c} value={c}>{c}</option>)}
            </select>

            <label style={S.label}>Phone (optional)</label>
            <input style={S.input} placeholder="e.g. (555) 555-5555" value={recommendForm.phone} onChange={setRecommend('phone')} type="tel" />

            <label style={S.label}>Your Review / Notes (optional)</label>
            <textarea style={S.textarea} placeholder="What did you like about them? Any details that would help others?" value={recommendForm.reviewer_note} onChange={setRecommend('reviewer_note')} />

            <button style={S.submitBtn(recommendSubmitting)} onClick={handleRecommendSubmit} disabled={recommendSubmitting}>
              {recommendSubmitting ? 'Submitting...' : 'Submit Recommendation'}
            </button>
            <button style={S.cancelBtn} onClick={() => setShowRecommend(false)}>Cancel</button>
          </div>
        </div>
      )}
    </>
  )
}

function ContractorCard({ contractor, catIcon, onSelect }) {
  return (
    <div style={S.card}>
      <div style={S.cardTop}>
        <span style={S.catBadge}>{catIcon} {contractor.category}</span>
        {contractor.verified && <span style={S.verifiedBadge}>✓ Verified</span>}
      </div>

      <div style={S.cardName}>{contractor.name}</div>

      <div style={S.ratingRow}>
        <Stars rating={contractor.rating} size={14} />
        <span style={S.ratingText}>
          {Number(contractor.rating).toFixed(1)} · {contractor.review_count} review{contractor.review_count !== 1 ? 's' : ''}
        </span>
      </div>

      {contractor.service_area && (
        <div style={S.detailLine}>📍 {contractor.service_area}</div>
      )}

      {contractor.phone && (
        <a href={`tel:${contractor.phone}`} style={S.phoneLink} onClick={e => e.stopPropagation()}>
          📞 {formatPhone(contractor.phone)}
        </a>
      )}

      <button style={S.viewBtn} onClick={() => onSelect(contractor)}>
        View Details →
      </button>
    </div>
  )
}
